import { DisputModel, DisputStatus } from '../model/types'

export const getDisputAmount = (disput: DisputModel) => {
  const disputAmountUSDT =
    disput.status === DisputStatus.Satisfied
      ? (disput.disputAmountFromTraderUsdt ?? disput.disputAmountFromMerchantUsdt)
      : disput.disputAmountFromMerchantUsdt

  const disputAmountRub =
    disput.status === DisputStatus.Satisfied
      ? (disput.disputAmountFromTrader ?? disput.disputAmountFromMerchant ?? 0)
      : (disput.disputAmountFromMerchant ?? 0)

  return { disputAmountRub, disputAmountUSDT}
}
